import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { ReportsRoute } from "./report.routes";

export function Report() {
  return (
    <Layout>
      {ReportsRoute.subRoutes && (
        <ModuleRouter subRoutes={ReportsRoute.subRoutes} path={ReportsRoute.path} />
      )}
    </Layout>
  );
}
